module.exports = __webpack_public_path__ + "img/HC3P_Carrousel_8.f73c9d48.jpg";